(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Tv', Tv);

    Tv.$inject = ['$resource'];

    function Tv ($resource) {
        var resourceUrl =  'api/tvs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
